import UploadFileRow from './UploadFileRow.component';

export default UploadFileRow;
